/**
 * Helper functions for Users component
 */

// Truncate text to specified length with ellipsis
export const truncateText = (text, length) => {
  if (!text) return '';
  return text.length > length ? `${text.substring(0, length)}...` : text;
};

// Get display text for status filter
export const getStatusDisplayText = (filterStatus) => {
  if (filterStatus === "active") return "Active";
  if (filterStatus === "deactive") return "Deactive";
  return "All";
};

// Get display text for date filter
export const getDateDisplayText = (dateFilter) => {
  if (dateFilter === "today") return "Today";
  if (dateFilter === "yesterday") return "Yesterday";
  if (dateFilter === "week") return "This Week";
  if (dateFilter === "month") return "This Month";
  if (dateFilter === "lastMonth") return "Last Month";
  return "All";
};

// Get display text for gender filter
export const getGenderDisplayText = (genderFilter) => {
  if (genderFilter === "Male") return "Men";
  if (genderFilter === "Female") return "Women";
  return "All";
};

// Get display text for payment filter
export const getPaymentDisplayText = (askPaymentFilter) => {
  if (askPaymentFilter === "true") return "True";
  if (askPaymentFilter === "false") return "False";
  return "All";
};

// Get display text for photo filter
export const getPhotoDisplayText = (isPhotoApprovedFilter) => {
  if (isPhotoApprovedFilter === "true") return "True";
  if (isPhotoApprovedFilter === "false") return "False";
  return "All";
};

// Get display text for photo approval status
export const getPhotoApprovalText = (isApproved) => {
  return isApproved ? "Approved" : "Not Approved";
};

// Get color for photo approval status
export const getPhotoApprovalColor = (isApproved) => {
  return isApproved ? "#4caf50" : "#ff5252";
};

// Calculate profile completion percentage based on 4 factors
export const calculateProfileCompletion = (userData) => {
  if (!userData) return 0;
  
  let percentage = 0;
  
  // Each factor contributes 25% to the total - check for multiple possible field names
  if (userData.IsPhoto || userData.isPhoto || userData.isPhotoApproved) percentage += 25;
  if (userData.IsVideo || userData.isVideo) percentage += 25;
  if (userData.Mob_Verify || userData.mob_verify || userData.isVerified) percentage += 25;
  if (userData.SetCV || userData.setCV || userData.isCvApproved) percentage += 25;
  
  return percentage;
};

// Get class name based on profile completion percentage
export const getProfileCompletionClass = (percentage) => {
  // Handle undefined or NaN
  if (percentage === undefined || isNaN(percentage)) {
    return "users-profile-button-red";
  }
  
  if (percentage < 25) return "users-profile-button-red";
  if (percentage < 50) return "users-profile-button-orange";
  if (percentage < 75) return "users-profile-button-amber";
  if (percentage < 100) return "users-profile-button-green";
  return "users-profile-button-blue";
};

// Get user status text based on userStatus value
export const getUserStatusText = (userStatus) => {
  // Handle numeric or string values, and default to "Inactive" for invalid values
  if (userStatus === 0 || userStatus === "0") return "Active";
  return "Inactive";
};

// Get user status color based on userStatus value
export const getUserStatusColor = (userStatus) => {
  // Handle numeric or string values, and default to red for invalid values
  if (userStatus === 0 || userStatus === "0") return "#4caf50"; // Green for active
  return "#ff5252"; // Red for inactive
};
